import React from 'react';
import { MDBIcon } from 'mdb-react-ui-kit';
import { Link } from 'react-router-dom';

const PaymentSuccess = () => {
  return (
    <>
      <section className="h-100 h-custom">
        <div className="text-center">
          <MDBIcon fas icon="check-circle" className="text-success" size="4x" />
          <h2 className="mt-4">Payment Successful</h2>
          <Link to="/e-commerce/product-list" className="btn btn-primary mt-4">Back to Shopping</Link>
        </div>
      </section>
    </>
  );
};

export default PaymentSuccess;